<template>
  <modal class="logout-modal" :closeBtn="allowClose">
    <template v-slot:header>
      <p>
        {{ confirmed ? "Logging Out" : "Log Out" }}
      </p>
    </template>
    <p>
      {{
        confirmed
          ? "Logging out of the SLC Applicant Portal..."
          : "Are you sure you want to log out?"
      }}
    </p>
    <template v-slot:footer>
      <div v-if="!confirmed" class="footer-btns">
        <button type="button" class="btn btn-secondary" @click.prevent="$emit('close')">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" @click.prevent="confirmLogout">Logout</button>
      </div>
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapState } from "vuex";
import useSignOut from "../../use/signout";
import Modal from "../shared/Modal.vue";

export default defineComponent({
  setup() {
    const { signOut } = useSignOut();
    return { signOut };
  },
  components: {
    Modal,
  },
  data: () => ({
    allowClose: true,
    confirmed: undefined as any,
  }),
  computed: {
    ...mapState(["lenderData"]),
  },
  methods: {
    ...mapActions("oidcStore", ["removeOidcUser", "signOutOidcSilent"]),
    confirmLogout() {
      this.confirmed = true;
      this.allowClose = false;
      this.signOut();
    },
  },
});
</script>

<style>
.logout-modal .modal-wrapper .modal-container .modal-body {
	min-height: 65px;
  max-height: 100px;
  padding: 1.563rem 1.5rem;
	padding-bottom: 0;
}
.logout-modal .modal-wrapper .modal-container .modal-header {
  max-height: 50px;
}
.logout-modal .modal-container {
  max-width: 400px;
}
</style>

<style scoped>
.footer-btns button {
  margin-left: 15px;
}

.footer-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 75px;
  width: 100%;
}
</style>
